import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"

import {
	OutboxAnalysisResponse,
	OutboxMessageCategory,
	OutboxMessagesResponse,
	RetryOutboxMessageRequest,
} from "./types"

export const getOutboxMessages = (
	apiClient: APIClient,
): Promise<OutboxMessagesResponse> =>
	apiClient.get("/outbox-messages").then(response => response.data)

export const retryOutboxMessage = (
	apiClient: APIClient,
	id: string,
	category: OutboxMessageCategory,
): Promise<void> =>
	apiClient
		.patch<RetryOutboxMessageRequest>(`/outbox-messages/${id}`, {
			category,
		})
		.then(() => {})

export const analyzeOutboxMessage = (
	apiClient: APIClient,
	id: string,
	category?: OutboxMessageCategory,
): Promise<OutboxAnalysisResponse> =>
	apiClient
		.get(`/outbox-messages/${id}/analysis`, {
			params: { category },
		})
		.then(response => response.data)
